<template>
  <router-view></router-view>
</template>
<script>
  export default {
    name: 'Box',
  };
</script>
